import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import { IMAGE_LIMITS } from '../../../utils/constants';
import { getFileUploadTypes } from '../../../utils/utilities';

import toastService from '../../../services/toastService';
import Button from '../../themed/button';
import Label from '../../themed/label';

class VIPhotoRecordForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
		places: [],
	};

	static propTypes = {
		initialGeneralPhotos: PropTypes.array,
		onProceed: PropTypes.func,
	};

	schema = {
		images: Joi.array().min(2).max(IMAGE_LIMITS.GENERAL_PHOTOS).required().label('Images'),
	};

	componentDidMount() {
		if (this.props.initialGeneralPhotos) {
			this.setState({ data: { images: this.props.initialGeneralPhotos }});
		}
	}

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.images);
		toastService.success('Images Saved Successfully!');
	};

	handleClearImages = () => {
		this.props.onProceed([]);
		this.setState({ data: { images: [] }});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
				<div className="d-flex justify-content-end align-items-center mb-3 gap-3">
					<Label label={`${this.state.data.images.length} Photos`} />

					<div>
						<Button
							label="Clear All Images"
							icon="trash"
							onClick={this.handleClearImages}
						/>
					</div>
				</div>

				{this.renderFileInput({
					max: IMAGE_LIMITS.GENERAL_PHOTOS,
					multiple: IMAGE_LIMITS.GENERAL_PHOTOS > 1,
					name: 'images',
					accept: 'image/*,application/pdf',
					label: 'Images',
					sublabel: 'Upload Visual Inspection Photograpic Data',
					types: getFileUploadTypes(),
					enforceImageCaptionUpdate: true
				})}

				<div className="d-flex justify-content-end align-items-center ">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

const initialData = { images: [] };
export default VIPhotoRecordForm;
